import React from "react";

const Merge = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="m19.744 33.28 13.535-13.536C33.744 19.28 34 18.66 34 18a2.45 2.45 0 0 0-.72-1.743L19.743 2.72A2.447 2.447 0 0 0 17.999 2c-.658 0-1.278.256-1.742.721L2.72 16.256A2.446 2.446 0 0 0 2 18c0 .659.255 1.28.72 1.744L16.258 33.28c.96.961 2.525.961 3.487 0Zm-8.678-19.283c-.18-.184-.35-.358-.515-.523l2.362-2.362c.179.18.357.362.543.554 1.64 1.68 3.604 3.694 7.534 4.4a5.24 5.24 0 0 0-.138-.485l-.218-.632c-.458-1.328.113-1.764 1.271-.968l3.736 2.568h.001l2.105 1.447-2.106 1.447-3.736 2.567c-1.157.795-1.73.36-1.271-.969l.218-.63c.052-.152.098-.315.138-.486-3.93.707-5.894 2.72-7.534 4.402-.186.191-.365.373-.543.552l-2.362-2.36.515-.524c1.206-1.237 2.749-2.82 5.136-4-2.386-1.178-3.93-2.76-5.136-3.998Z"
            fill={fill}
        />
    </svg>
);

export default Merge;